import { createSlice } from "@reduxjs/toolkit";
import { StorageHelpers } from "../../core/Helpers";

const initialState = {
  token: null,
  userToken: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setUserToken: (state, action) => {
      state.userToken = action.payload;
    },

    checkUserToken: (state, action) => {
      const userToken = StorageHelpers.getUserAuthToken();
      if (userToken !== null) {
        state.userToken = userToken;
      }
    },
    checkToken: (state, action) => {
      const token = StorageHelpers.getAuthToken();
      if (token !== null) {
        state.token = token;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setToken, checkToken, setUserToken, checkUserToken } =
  authSlice.actions;

export default authSlice.reducer;
